import { initCartFooter } from '@/scripts/cart/cart-footer';

document.addEventListener('DOMContentLoaded', function () {
  initCartFooter();
});
